module.exports = "/static/media/edit_file.f4c90a37.svg";